import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   ADD_PURCHASE_RETURN_INVOICE,
   GET_PURCHASE_RETURN_INVOICES,
   GET_PURCHASE_RETURN_INVOICES_FOR_DAYBOOK,
   GET_PURCHASE_RETURN_INVOICES_TRANSACTIONS,
   GET_PURCHASE_RETURN_INVOICE,
   UPDATE_PURCHASE_RETURN_INVOICE,
   DELETE_PURCHASE_RETURN_INVOICE,
   LAST_BILL_PURCHASE_RETURN_INVOICE,
   GET_LAST_PURCHASE_RETURN_DAYBOOK,
   GET_ONE_PURCHASE_RETURN,
   GET_PURCHASE_RETURN_LINE_ITEMS,
   ADD_PURCHASE_RETURN_LINE_ITEM,
   UPDATE_PURCHASE_RETURN_LINE_ITEM,
   DELETE_PURCHASE_RETURN_LINE_ITEM,
   EMPTY_ONE_PURCHASE_RETURN,
   GET_PURCHASE_RETURN_INVOICE_WITH_PREV_AND_NEXT,
   GET_PURCHASE_RETURN_INVOICE_PREV_AND_NEXT,
   DELETE_MULTI_PURCHASE_RETURN_INVOICE,
} from '../types';

// ======================== PURCHASE RETURN ========================

export const deleteMultiPurchaseReturnInvoice = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post("/purchaseReturnInvoice/delete/multi", formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_PURCHASE_RETURN_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchase Invoice deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

// Add Purchase Return
export const addPurchaseReturnInvoice = (data) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchaseReturnInvoice/add`, data);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_PURCHASE_RETURN_INVOICE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Purchase Return Invoice added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
         return error.response.data;
      }
   }
};

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/purchaseReturnInvoice/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

// Get Purchase Return Invoices
export const getPurchaseReturnInvoices = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchaseReturnInvoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_RETURN_INVOICES,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

export const getPurchaseReturnInvoicesForDaybook = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchaseReturnInvoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_RETURN_INVOICES_FOR_DAYBOOK,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

export const getPurchaseReturnInvoicestransactions = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchaseReturnInvoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_RETURN_INVOICES_TRANSACTIONS,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

// Get Single Purchase Return Invoice
export const getPurchaseReturnInvoice = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchaseReturnInvoice/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_RETURN_INVOICE,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

// Update Purchase Return Invoice
export const updatePurchaseReturnInvoice = (data) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchaseReturnInvoice/update`, data);
      if (res.data.code === 1) {
         dispatch({
            type: UPDATE_PURCHASE_RETURN_INVOICE,
            payload: res.data.data,
         });
         setTimeout(() => {
            toast.success('Sale Return Invoice updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
         return error.response.data;
      }
   }
};

// Delete Purchase Return Invoice
export const deletePurchaseReturnInvoice = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchaseReturnInvoice/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_PURCHASE_RETURN_INVOICE, payload: { id } });
         setTimeout(() => {
            toast.success('Purchase Return Invoice deleted successfully!');
         }, 1000);
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

// Last Bill Purchase Return Invoice
export const lastBillPurchaseReturnInvoice = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/purchaseReturn/last-billNo`, {
         params,
      }); //pass Daybook ID
      if (res.data.code === 1) {
         dispatch({
            type: LAST_BILL_PURCHASE_RETURN_INVOICE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getLastPurchaseReturnDaybook = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/purchaseReturn/last`, { params });
      const res = await axios.get(`/purchaseReturnInvoice/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_LAST_PURCHASE_RETURN_DAYBOOK,
            payload: res.data.data,
         });
      }
   } catch (err) {
      console.error('getLastPurchaseReturnDaybook err', err);
   }
};

export const getSinglePurchaseReturn = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/purchaseReturn/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_PURCHASE_RETURN, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getSinglePurchaseReturnWithPrevAndNext = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchaseReturnInvoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_RETURN_INVOICE_WITH_PREV_AND_NEXT,
            payload: res.data,
         });
         return res.data.data;
      }
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

export const getPrevAndNext = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/purchaseReturn/prev-next`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_PURCHASE_RETURN_INVOICE_PREV_AND_NEXT, payload: res.data.data });
      }
      return res.data.data;
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};
// ======================== PURCHASE RETURN ========================

// ======================== PURCHASE RETURN LINE ITEM ========================

export const getPurchaseReturnLineItems = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/purchaseReturnLineItem/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_RETURN_LINE_ITEMS,
            payload: res.data.data,
         });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error("Failed to get Size. Please try again. :", err);
   }
};

export const addPurchaseReturnLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/purchaseReturnLineItem/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_PURCHASE_RETURN_LINE_ITEM, payload: res.data.data });
         setTimeout(() => {
            toast.success('SalesLineItem added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updatePurchaseReturnLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/purchaseReturnLineItem/update`, formData);

      if (res.data.code === 1) {
         dispatch({
            type: UPDATE_PURCHASE_RETURN_LINE_ITEM,
            payload: res.data.data,
         });

         setTimeout(() => {
            toast.success('SalesLineItem updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error("Failed to update Size. Please try again.");
   }
};

export const deletePurchaseReturnLineItem = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/purchaseReturnLineItem/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_PURCHASE_RETURN_LINE_ITEM, payload: { id } });
         setTimeout(() => {
            toast.success('SalesLineItem deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error("Failed to delete Size. Please try again.");
   }
};

export const getPurchaseReturnLineItem = (id) => async (dispatch) => {
   const res = await axios.get(`/purchaseReturnLineItem/${id}`);
   if (res.data.code === 1) {
      dispatch({ type: GET_PURCHASE_RETURN_LINE_ITEMS, payload: res.data.data });
   }
   return res.data.code;
};

// ======================== PURCHASE RETURN LINE ITEM ========================

export const emptyPurchaseReturn = () => async (dispatch) => {
   console.log('reset...');
   dispatch({ type: EMPTY_ONE_PURCHASE_RETURN, payload: null });
};
